import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UserDTO } from '../model/UserDTO';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticateService {

  private BASE_URL = '/Account';
  private FORGOT = '/forgotPassword';
  private RESET_PASSWORD = '/resetPassword';

  constructor(private http: HttpService) { }

  forgot(email: string) {
    var httpParams = new HttpParams();
    httpParams = httpParams.append('email', email);
    return this.http.post<UserDTO>(this.BASE_URL + this.FORGOT, httpParams, null, false, false).pipe(
      map(response => {
        var obj = new UserDTO();
        obj.fillFromJSON(response);
        return obj;
      })
    );
  }

  resetPassaword(token: string, password: string, confirmPassword: string) {
    let body = {
      password: password,
      confirmPassword: confirmPassword,
      token: token
    }
    return this.http.post<UserDTO>(this.BASE_URL + this.RESET_PASSWORD, null, body, false).pipe(
      map(response => {
        var obj = new UserDTO();
        obj.fillFromJSON(response);
        return obj;
      })
    );
  }

  /*getValidationCode(areaCode: string, phone: string): Observable<any> {
    var httpParams = new HttpParams();
    httpParams = httpParams.append('areaCode', areaCode);
    httpParams = httpParams.append('phone', phone);
    return this.http.get<any>(this.BASE_URL + this.VALIDATION_CODE_URL, httpParams, false);
  }*/
  /*authenticate(areaCode: string, phone: string, validationCode: string): Observable<UserDTO> {
    let body = {
      AreaCode: areaCode,
      Phone: phone,
      ValidationCode: validationCode
    }
    return this.http.post<UserDTO>(this.BASE_URL + this.AUTHENTICATE_CODE_URL, body, false).pipe(
      map(response => {
        var obj = new UserDTO();
        obj.fillFromJSON(response);
        return obj;
      })
    );
  }*/
}
